import type { ColumnDef } from '@tanstack/react-table'
import type { REndpoint } from 'v2/api-console/voice/endpoints/types'

export const linkedEndpointsColumns: ColumnDef<REndpoint>[] = [
  {
    accessorKey: 'alias',
    header: 'Endpoint details',
    cell: ({ row }) => {
      const endpoint = row.original
      return (
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <span className="text-s-600 shrink-0">Alias:</span>
            <span className="text-s-400">{endpoint.alias || '—'}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-s-600 shrink-0">SIP URI:</span>
            <span className="text-xs-400 break-all font-jetbrains">{endpoint.sip_uri || '—'}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-s-600 shrink-0">Username:</span>
            <span className="font-jetbrains text-xs-400">{endpoint.username || '—'}</span>
          </div>
        </div>
      )
    },
  },
]
